import {connect} from 'react-redux';

import Match from '../Match.jsx';

function select(state, props) {
    const match = state.application.getIn(['live', 'matches', props.matchId]);
    const scores = state.application.getIn(['live', 'scores']);
    const displayMode = state.application.get('displayMode');

    return {
        ...props,
        displayMode,
        match,
        scores
    };
}

export default connect(select)(Match, null, null, false);



// WEBPACK FOOTER //
// ./js/sport-betting/components/menu/live/Match.jsx